import CredentialsHeader from "@/components/header/Header";
import { useTranslation } from "react-i18next";

export default function ContactCenter() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-12 pb-2">
      <CredentialsHeader
        title={t("site_credentials.contact_center.header_title")}
        subtitle=""
        isTextAlignCenter
      />
    </div>
  );
}
